export const SET_ACCOUNT_MANAGERS = 'SET_ACCOUNT_MANAGERS';
export const SET_USER_LIST = 'SET_USER_LIST';
export const ADD_TO_USER_LIST = 'ADD_TO_USER_LIST';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';